const files = import.meta.glob("@/assets/clients/*.webp", { eager: true, import: "default" }) as Record<string, string>;
const src = (n: string) => files[Object.keys(files).find((k) => k.endsWith(`/${n}.webp`))!];

// [file, alt, boxed] — boxed logos keep their own background as a rounded tile
const LOGOS: [string, string, boolean][] = [
  ["scott-rm", "Scott Risk Management", false],
  ["nrds", "Nigel Richards Driving School", false],
  ["moneypenny", "Moneypenny", false],
  ["xgas", "Xgas", false],
  ["max-performance", "Max Performance", false],
  ["sub86", "Sub86 Ice Blasting", true],
  ["billington-autos", "Billington Autos", true],
  ["dwyer", "Dwyer Construction", false],
  ["moneypenny", "Moneypenny", false],
  ["nrds", "Nigel Richards Driving School", false],
  ["optimised-wellbeing", "Optimised Wellbeing", true],
  ["fredstone", "Fredstone Luxury Landscapes", false],
  ["xgas", "Xgas", false],
  ["scottrm-genie", "ScottRM Genie", true],
  ["green-scene", "Green Scene Group", true],
  ["moneypenny", "Moneypenny", false],
  ["engine-works", "The Engine Works", false],
  ["bespoke", "Bespoke Home & Garden Solutions", false],
  ["jans-counselling", "Jan's Counselling", true],
  ["hire-class-2", "Hire Class", false],
  ["rooted-play-therapy", "Rooted Play Therapy", false],
  ["hire-class", "Client logo", false],
];

const LogoStripV2 = () => {
  const loop = [...LOGOS, ...LOGOS];
  return (
    <section className="py-8 bg-background border-y border-foreground/5">
      <div className="container mx-auto px-6 mb-6">
        <p className="text-center text-xs uppercase tracking-[0.2em] text-muted-foreground">Trusted by local businesses</p>
      </div>
      <div
        className="relative overflow-hidden"
        style={{
          maskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
          WebkitMaskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
        }}
      >
        <div className="flex w-max items-center animate-[marquee_50s_linear_infinite] gap-14 px-7 hover:[animation-play-state:paused]">
          {loop.map(([f, alt, boxed], i) => (
            <img
              key={`${f}-${i}`}
              src={src(f)}
              alt={i < LOGOS.length ? alt : ""}
              aria-hidden={i >= LOGOS.length}
              loading="lazy"
              decoding="async"
              className={`w-auto object-contain opacity-80 transition-opacity hover:opacity-100 ${f === "engine-works" ? "h-6 md:h-7" : f === "moneypenny" ? "h-8 md:h-10" : "h-12 md:h-14"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoStripV2;
